import { ButtonProps } from '../Button';
import AffiliateButton from './AffiliateButton';
import NFHSImage from 'images/icons/nfhs.png';

export default function NFHSButton(props: ButtonProps) {
  return <AffiliateButton {...props} image={NFHSImage} />;
}
